import { Component } from '@theme/component';

class APCatalogMenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }
  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }
  initialize() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.categories = [...this.querySelectorAll('[data-category]')];
    this.panels = [...this.querySelectorAll('[data-panel]')];
    if (!this.categories.length) return;
    this.querySelector('.ap-catalog__categories').setAttribute('role', 'tablist');
    this.querySelector('.ap-catalog__categories').setAttribute('aria-orientation', 'vertical');
    for (const category of this.categories) {
      category.setAttribute('role', 'tab');
      category.setAttribute('aria-controls', category.hash.slice(1));
      category.addEventListener('click', event => {
        event.preventDefault();
        this.select(category);
      }, { signal: this.controller.signal });
      category.addEventListener('keydown', event => {
        let index = this.categories.indexOf(category);
        if (event.key === 'ArrowDown') index = (index + 1) % this.categories.length;
        else if (event.key === 'ArrowUp') index = (index - 1 + this.categories.length) % this.categories.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.categories.length - 1;
        else if (event.key === ' ') { event.preventDefault(); this.select(category); return; }
        else return;
        event.preventDefault();
        this.select(this.categories[index]);
        this.categories[index].focus();
      }, { signal: this.controller.signal });
    }
    for (const panel of this.panels) panel.setAttribute('role', 'tabpanel');
    this.select(this.categories.find(category => category.getAttribute('aria-selected') === 'true') || this.categories[0]);
    this.dataset.enhanced = '';
  }
  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }
  select(selected) {
    for (const category of this.categories) {
      const active = category === selected;
      category.setAttribute('aria-selected', String(active));
      category.tabIndex = active ? 0 : -1;
    }
    for (const panel of this.panels) panel.hidden = panel.dataset.panel !== selected.dataset.category;
  }
}
if (!customElements.get('ap-catalog-menu')) customElements.define('ap-catalog-menu', APCatalogMenu);
